var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-field search-field--destination" },
    [
      _c("input-field", {
        attrs: {
          name: _vm.translations.destination,
          readonly: true,
          value: _vm.selectedDestinationAirportName,
          "icon-type": "plane-to",
          error: _vm.validation.destinationId,
          "disable-blur": true,
          disable: _vm.disabled
        },
        on: { focus: _vm.showDestinationSearch }
      }),
      _vm._v(" "),
      _vm.showSelector == "destination-selector"
        ? _c(
            "modal",
            {
              staticClass: "modal--search-widget",
              attrs: {
                title: _vm.translations.destination,
                "close-on-click": true,
                "is-open": _vm.openModal == "destination-selector"
              },
              on: { close: _vm.onCloseDestinationAirport }
            },
            [
              _c("img", {
                attrs: {
                  slot: "icon",
                  src: require("../../../assets/img/icons/icon-plane-arrival.svg"),
                  alt: ""
                },
                slot: "icon"
              }),
              _vm._v(" "),
              _c("input-field", {
                ref: "searchField",
                class: { "item-loading": _vm.loadingDestinations },
                attrs: {
                  name: _vm.translations.search_txt,
                  value: _vm.destinationSearchVal,
                  "icon-type": "plane-to"
                },
                on: {
                  input: function(val) {
                    return (_vm.destinationSearchVal = val)
                  },
                  stopTyping: function(val) {
                    return _vm.getDestinations(val)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "modal-view-list",
                  class: { loading: _vm.loadingDestinations }
                },
                _vm._l(_vm.desitinationList, function(airport, key) {
                  return _c(
                    "li",
                    {
                      key: key,
                      staticClass: "modal-view-list__item",
                      class: {
                        "modal-view-list__item--special":
                          airport.type === "special"
                      },
                      on: {
                        click: function($event) {
                          _vm.selectDestinationAirport(airport)
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: airport.thumbnail || _vm.defaultImage,
                          alt: airport.name
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "modal-view-list__item__content" },
                        [
                          _c("p", {
                            domProps: { textContent: _vm._s(airport.name) }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(_vm.getType(airport.type))
                            }
                          })
                        ]
                      )
                    ]
                  )
                })
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b0321580", { render: render, staticRenderFns: staticRenderFns })
  }
}